import React from 'react';
import HRTeamPage from '../pages/team-management';
import ViewTeamPage from '../pages/team-management/view-team';
import ProtectedRoute from './protected';

export const TeamRoutes = [
  <ProtectedRoute exact path='/team' component={HRTeamPage} />,
  <ProtectedRoute exact path='/team/view/:id' component={ViewTeamPage} />,
];